import { render } from "./MassServiceAcknowledge.vue?vue&type=template&id=212ded3f"
import script from "./MassServiceAcknowledge.vue?vue&type=script&lang=js"
export * from "./MassServiceAcknowledge.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__